import React from "react";
import styled from "styled-components";
import moment from "moment";
import momentTz from "moment-timezone";
import { useCurrentUserTimezone } from "core/hooks/useCurrentTimeZone";

export interface InvisibleBlockProps {
  id: string;
  endTime: moment.Moment;
  startTime: moment.Moment;
}

const InvisibleBlock = styled.div`
  display: none;
`;

export const mapScheduleToInvisibleBlock = (schedule: InvisibleBlockProps) => {
  const { id, endTime, startTime } = schedule;
  const timezone = useCurrentUserTimezone();
  return {
    node: <InvisibleBlock />,
    endAt: endTime ? momentTz.tz(endTime, timezone) : null,
    i: id,
    isDraggable: false,
    isResizable: false,
    startAt: startTime ? momentTz.tz(startTime, timezone) : null,
  };
};
